import { PointOfInterest } from '@/__generated__/graphql';
import { generatePoiDisplayName } from '@/components/Analysis/modules/pointOfInterest/PointOfInterestTab/SelectedPoiContent/utils';
import { Box, Stack } from '@mui/material';
import { useMemo } from 'react';
import { Arrow, Content, Title } from './styles';

export const PointOfInterestAnnotation = ({
  pointOfInterest,
  height = 0,
  scale = 1,
  swivel = false,
  selectedSpherical = false,
  selected = false,
}: {
  pointOfInterest: PointOfInterest;
  height?: number;
  scale?: number;
  swivel?: boolean;
  selectedSpherical?: boolean;
  selected?: boolean;
}) => {
  const poiName = generatePoiDisplayName({
    name: pointOfInterest.name,
    poiId: pointOfInterest.poiId,
    poiType: pointOfInterest.type,
  });
  const barHeight = useMemo(() => height * 10 * (swivel ? 1.5 : 1), [height, swivel]);
  const randomAngle = useMemo(() => Math.random() * 75 * (Math.random() > 0.5 ? 1 : -1), []);
  return (
    <Stack
      data-testid="poi-annotation-container"
      sx={{
        userSelect: 'none',
        width: 'fit-content',
        minWidth: 'fit-content',
        marginBottom: `${barHeight + (selectedSpherical ? 70 : 100) + (selected ? 20 : 0)}px`,
        transform: swivel ? `rotate(${randomAngle}deg)` : '',
        transformOrigin: 'bottom',
      }}
    >
      <Content
        data-testid="poi-annotation-content"
        sx={{
          transform: `${swivel ? `rotate(${randomAngle * -1}deg)` : ''} scale(${scale})`,
          transformOrigin: 'bottom',
        }}
      >
        <Stack direction="row" alignItems="center" gap="2.4rem">
          <Title data-testid="poi-annotation-title">{poiName}</Title>
        </Stack>
      </Content>
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Arrow
          data-testid="poi-annotation-arrow"
          sx={{
            transform: swivel ? `rotate(${randomAngle * -1}deg)` : '',
            transformOrigin: 'top',
          }}
        />
        <Box
          data-testid="poi-annotation-bar"
          sx={{
            height: `${barHeight}px`,
            width: `calc(0.1rem * ${scale})`,
            backgroundColor: 'white',
          }}
        />
      </Box>
    </Stack>
  );
};
